import { Container, Stack, Flex, Heading, Text } from '@chakra-ui/react';

export default function HeroWithLeftMedia({ title, subTitle, cta, media }) {
  return (
    <Container maxW="6xl">
      <Stack
        align="center"
        gap={{ base: 5 }}
        py={{ base: 5, md: 10 }}
        direction={{ base: 'column', md: 'row' }}>
        <Flex
          flex={1}
          justify="center"
          align="center"
          position="relative"
          w="full">
          { media }
        </Flex>
        <Stack flex={1} gap={{ base: 5, md: 10 }}>
          <Heading
            fontWeight={600}
            fontSize={'3xl'}>
            { title }
          </Heading>
          <Text whiteSpace="pre-line">
            { subTitle }
          </Text>
          <Stack
            gap={{ base: 4, sm: 6 }}
            direction={{ base: 'column', sm: 'row' }}>
            { cta }
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
}
